module.exports = __webpack_public_path__ + "static/media/epitechLogo.c3868738.png";